import React, { useState } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigateWithScrollMemory } from '../../hooks/useNavigateWithScrollMemory';
import defaultArticleThumbnail from '../../assets/default_article_thumbnail.svg';
import CommentCount from '../common/CommentCount';
import BookmarkCount from '../common/BookmarkCount';
import CardTitle from '../common/CardTitle';
import theme from '../../theme';

const NoticeVerticalCard = ({
  notice,
  actionButton,
  coverActionButton,
  inlineStats = false,
  referrerType,
}) => {
  const navigateWithScrollMemory = useNavigateWithScrollMemory();
  const [imageError, setImageError] = useState(false);
  const noticeUrl = `/notice/${notice.slug || notice.id}`;

  const handleClick = (e) => {
    if (!e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      navigateWithScrollMemory(noticeUrl, referrerType ? { state: { referrerType } } : undefined);
    }
  };

  const handleError = () => {
    if (!imageError) setImageError(true);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: { md: '12px', lg: '16px' },
        position: 'relative',
        minWidth: 0,
      }}
    >
      {/* 이미지 */}
      <Box
        component={RouterLink}
        to={noticeUrl}
        state={referrerType ? { referrerType } : undefined}
        onClick={handleClick}
        sx={{ display: 'block', width: '100%', flexShrink: 0, position: 'relative' }}
      >
        <Box
          component="img"
          src={imageError || !notice.imageUrl ? defaultArticleThumbnail : notice.imageUrl}
          alt={imageError || !notice.imageUrl ? 'Default article thumbnail' : notice.title}
          onError={handleError}
          sx={{
            width: '100%',
            aspectRatio: '280 / 188',
            cursor: 'pointer',
            objectFit: 'cover',
            display: 'block',
            border: `1px solid ${theme.palette.grey.line}`,
          }}
        />
        {coverActionButton && (
          <Box
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
            }}
            sx={{
              position: 'absolute',
              top: { xs: 8, md: 10 },
              right: { xs: 8, md: 10 },
              zIndex: 3,
            }}
          >
            {coverActionButton}
          </Box>
        )}
      </Box>

      {/* 정보 영역 */}
      <Box
        sx={{
          flex: 1,
          width: '100%',
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <CardTitle
          title={notice.title}
          to={noticeUrl}
          onClick={handleClick}
          sx={{ fontSize: { md: 14, lg: 16 }, fontWeight: 'bold' }}
        />

        {/* 하단 정보 + actionButton */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            mt: { md: '12px', lg: '16px' },
          }}
        >
          {inlineStats ? (
            <Box
              display="flex"
              gap={1}
              alignItems="center"
              sx={{ mt: { md: '12px', lg: '16px' } }}
            >
              {notice.createdAt && (
                <>
                  <Typography
                    fontSize={14}
                    sx={{ color: theme.palette.black[4], whiteSpace: 'nowrap' }}
                  >
                    {notice.createdAt}
                  </Typography>
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                      height: '8px',
                      alignSelf: 'center',
                      backgroundColor: theme.palette.grey.line,
                    }}
                  />
                </>
              )}
              <Box display="flex" gap={{ xs: 1, md: 1.5 }} alignItems="center">
                <CommentCount commentCount={notice.commentCount} />
                <BookmarkCount bookmarkCount={notice.bookmarkCount} />
              </Box>
            </Box>
          ) : (
            <Box>
              {notice.createdAt && (
                <Typography
                  fontSize={14}
                  sx={{ color: theme.palette.black[4], whiteSpace: 'nowrap' }}
                >
                  {notice.createdAt}
                </Typography>
              )}
              <Box
                display="flex"
                gap={1.5}
                alignItems="center"
                sx={{ mt: { md: '12px', lg: '16px' } }}
              >
                <CommentCount commentCount={notice.commentCount} />
                <BookmarkCount bookmarkCount={notice.bookmarkCount} />
              </Box>
            </Box>
          )}

          {/* 우측: actionButton */}
          {actionButton}
        </Box>
      </Box>
    </Box>
  );
};

export default NoticeVerticalCard;
